import MetricChart from './MetricChart';

export * from './MetricChart';
export default MetricChart;
